import { createFileRoute } from "@tanstack/react-router";

import { parseMarketSearch } from "@/features/administration";
import { CourseBonusPage } from "@/features/administration/pages";
import { strictSearch } from "@/shared/lib/search";

/** The bonus for a course done whole in the app by one specialist, a market at a time. */
export const Route = createFileRoute("/_app/settings/course-bonus")({
  validateSearch: strictSearch(parseMarketSearch),
  component: CourseBonus,
});

function CourseBonus() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <CourseBonusPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate({ search: next, replace: options?.replace === true })
      }
    />
  );
}
